/**
 * @module experience/shared-experience
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */

// Core
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '@support/shared/widgets/widgets.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AemModule } from '@core/aem/aem.module';

// Components
import { ServiceDepositsComponent } from '@experience/shared-experience/components/service-deposits/service-deposits.component';
import { TermsAndConditionsComponent } from '@experience/shared-experience/components/terms-and-conditions/terms-and-conditions.component';
import { DynamicPinFormComponent } from '@experience/shared-experience/components/dynamic-pin-form/dynamic-pin-form.component';
import { RedeemCardComponent } from '@experience/shared-experience/components/redeem-card/redeem-card.component';
// Services
import { ConfirmationComponent } from '@experience/refill-account/refill/components/confirmation/confirmation.component';
import { ReviewComponent } from '@experience/refill-account/refill/components/review/review.component';
import { RedeemCardBillingDetailsComponent } from '@experience/refill-account/refill/shared/billing-details/redeem-card-billing-details.component';
import { RedeemCardFundDetailsComponent } from '@experience/refill-account/refill/shared/fund-details/redeem-card-fund-details.component';
import { ShippingInformationComponent } from '@experience/shared-experience/components/shipping-information/shipping-information.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

// TODO: This logic has to be removed in upcoming drops
// tslint:disable
export function getCaptchaKey() {
  if (window.location.hostname.indexOf('rebellion') > -1) {
    return '6Ldcv6IUAAAAAJrHWg6Gnp9xFKT5usbKf74AKuND';
  } else {
    return '6LeO-K4UAAAAADvLs1Bw0DI1XVgHmYG46mvIPnS2';
  }
}
// tslint:enable

@NgModule({
  imports: [
    CommonModule,
    WidgetsModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AemModule,
    InfiniteScrollModule,
  ],
  declarations: [
    ServiceDepositsComponent,
    TermsAndConditionsComponent,
    DynamicPinFormComponent,
    ReviewComponent,
    RedeemCardBillingDetailsComponent,
    RedeemCardFundDetailsComponent,
    ConfirmationComponent,
    RedeemCardComponent,
    ShippingInformationComponent,
  ],
  exports: [
    ServiceDepositsComponent,
    TermsAndConditionsComponent,
    DynamicPinFormComponent,
    RedeemCardComponent,
    ShippingInformationComponent,
  ]
})
export class SharedExperienceModule { }
